<template>
  <div data-test-id="decathlon-loader" class="vtmn-flex vtmn-justify-center vtmn-items-center" :class="sizeClass">
    <svg viewBox="-20 -20 480 411" class="decathlon-snake" aria-hidden="true">
      <path
        d="M273.854 5.73149C308.747 -1.16185 346.107 -3.68184 379.934 9.34482C396.414 16.3448 412.547 26.1448 422.92 41.1448C438.6 62.0648 440.987 90.0248 437.854 115.185C429.907 162.905 403.374 205.318 371.56 240.878C355.547 257.371 339.8 274.451 321.027 287.891C320.934 262.931 319.747 237.905 321.227 212.985C329.614 200.785 341.12 191.105 349.627 178.972C368.334 153.705 385.16 125.131 388 93.1315C389.92 79.6115 386.507 65.6115 379.24 54.1315C368.667 38.5715 350.307 30.4248 332.12 28.0915C297.667 22.4648 263.16 32.1715 231.214 44.4515C176.387 66.9048 126.694 101.625 86.5471 145.171C63.8538 169.905 44.4138 198.692 35.3204 231.305C32.4138 243.865 30.4538 257.038 32.9738 269.851C35.3071 281.145 44.0138 291.945 55.9738 293.292C75.9871 297.372 94.6138 286.598 110.294 275.572C141.107 251.438 166.374 221.171 190.947 190.945C220.947 152.838 249.6 113.598 275.214 72.3848C275.507 155.038 275.507 237.678 275.214 320.332C224.934 348.865 168.787 371.425 110.04 370.158C77.5738 370.385 43.0404 360.118 21.0938 334.998C6.08042 318.905 0.747092 296.345 0.080425 274.931C-0.466242 243.131 11.5604 212.651 26.6538 185.211C54.2804 138.171 93.6938 98.7448 138.16 67.5048C178.987 38.7182 224.907 16.4648 273.854 5.73149Z"
        fill="none"
        stroke="currentColor"
        stroke-width="18"
        pathLength="1000"
        stroke-dasharray="400 600"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
  },
});

const sizeClass = computed(() => {
  switch (props.size) {
    case "small":
      return "vtmn-w-6 vtmn-h-6";
    case "medium":
      return "vtmn-w-10 vtmn-h-10";
    case "large":
      return "vtmn-w-20 vtmn-h-20";
    default:
      return "vtmn-w-10 vtmn-h-10";
  }
});
</script>

<style scoped>
.decathlon-snake {
  width: 100%;
  height: 100%;
  color: #3642b8;
}

.decathlon-snake path {
  animation: dash-travel 1.1s linear infinite;
}

@keyframes dash-travel {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
</style>
